package diana.soleil.design.iraniancanadienbazzar.core.model

/**
 * A user-filed moderation report on some piece of content (`reports/{id}` — see `docs/DATA_MODEL.md`).
 * Filed by any signed-in user; read/resolved only by admins.
 */
data class Report(
    val id: String,
    val targetType: String,
    val targetId: String,
    val reporterUid: String,
    val reason: String,
    val status: ReportStatus,
    val createdAt: String? = null,
)

enum class ReportStatus { Open, Resolved }
